export const updateCompanyField = ({ companies, companyId, field, value }) => {
  if (!companies?.[companyId]) return companies;

  return {
    ...companies,
    [companyId]: {
      ...companies[companyId],
      [field]: value
    }
  };
};

export const updateCompanyFields = ({ companies, companyId, updates }) => {
  if (!companies?.[companyId]) return companies;

  return {
    ...companies,
    [companyId]: {
      ...companies[companyId],
      ...updates
    }
  };
};

export const toggleCompanyWorkDay = ({ companies, companyId, dayIndex }) => {
  if (!companies?.[companyId]) return companies;

  const currentDays = companies[companyId].workDays || [];
  const nextDays = currentDays.includes(dayIndex)
    ? currentDays.filter(day => day !== dayIndex)
    : [...currentDays, dayIndex].sort();

  return updateCompanyField({
    companies,
    companyId,
    field: 'workDays',
    value: nextDays
  });
};

export const incrementCompanyOvertime = ({ companies, companyId, minutes }) => {
  if (!companies?.[companyId]) return companies;

  return updateCompanyField({
    companies,
    companyId,
    field: 'overtimeMinutes',
    value: (companies[companyId].overtimeMinutes || 0) + minutes
  });
};

export const applyOnboardingCompanySettings = ({
  companies,
  companyId,
  onboardingData,
  parsedClients,
  parsedManagers,
  colorPalettes,
  fallbackName
}) => {
  const existingCompany = companies?.[companyId] || {};

  return {
    ...(companies || {}),
    [companyId]: {
      id: companyId,
      theme: colorPalettes[0],
      systemEnabled: false,
      systemUrl: '',
      driveEnabled: false,
      driveUrl: '',
      overtimeMinutes: 0,
      isClockedIn: false,
      clockInTime: null,
      attendanceLogs: [],
      ...existingCompany,
      name: fallbackName,
      systemEnabled: existingCompany.systemEnabled || false,
      systemUrl: existingCompany.systemUrl || '',
      driveEnabled: existingCompany.driveEnabled || false,
      driveUrl: existingCompany.driveUrl || '',
      clients: parsedClients,
      managers: parsedManagers,
      workStart: onboardingData.workStart || '09:00',
      workEnd: onboardingData.workEnd || '17:00',
      workDays: existingCompany.workDays || [0, 1, 2, 3, 4, 6],
      hourlyRate: Number(onboardingData.hourlyRate) || 0,
      theme: existingCompany.theme || colorPalettes[0]
    }
  };
};
